<template>
  <div>
    <pdf
      v-for="i in numPages"
      :key="generatePageKey(fileUrl, i)"
      :src="src"
      :page="i"
      :rotate="rotation"
      :style="styles"
      @page-loaded="onPageLoaded($event)"
    />
  </div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  components: {
    pdf
  },
  props: {
    fileUrl: { type: String, required: true },
    rotation: { type: Number, default: 0 },
    styles: { type: String, default: '' }
  },
  data() {
    return {
      numPages: 0,
      numPagesLoaded: 0,
      loaded: false,
      src: null
    }
  },
  watch: {
    fileUrl() {
      this.loaded = false
      this.numPages = 0
      this.numPagesLoaded = 0
      this.initializePdf()
    }
  },
  async mounted() {
    this.initializePdf()
  },
  methods: {
    generatePageKey(fileUrl, pageNumber) {
      return `${encodeURI(fileUrl)}-${pageNumber}}`
    },
    async initializePdf() {
      this.src = pdf.createLoadingTask(this.fileUrl)
      const resolvedPdf = await this.src.promise
      this.numPages = resolvedPdf.numPages
      this.$emit('num-pages', this.numPages)
      // https://github.com/FranckFreiburger/vue-pdf/issues/96#issuecomment-525715843
      this.src._worker.destroy()
    },
    onPageLoaded($event) {
      this.numPagesLoaded++
      this.handleLoading()
    },
    handleLoading() {
      if (!this.loaded && this.numPagesLoaded >= this.numPages) {
        this.loaded = true
        this.$emit('loaded')
      }
    }
  }
}
</script>
